import { MutationTree } from 'vuex';
import { AuthState } from '@/types/state';
import { UserDetailsInterface } from '@/types/auth';
import { getInitialState } from '.';

const mutations: MutationTree<AuthState> = {
  setAuthenticated(state, authenticated: boolean): void {
    state.authenticated = authenticated;
  },

  setUserDetails(state, details: UserDetailsInterface): void {
    state.userDetails = details;
  },

  reset(state): void {
    Object.assign(state, getInitialState());
  },

};

export default mutations;
